/*
* Broadcast Theme
*
* Use this file to add custom Javascript to Broadcast.  Keeping your custom
* Javascript in this fill will make it easier to update Broadcast. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/


(function() {
  // Add custom code below this line

  const validateEmail = (email) => {
    const re = /\S+@\S+\.\S+/
    return re.test(email)
  }

  window.addEventListener('theme:variant:change', e => {
    const { target, detail: { variant }} = e

    if (!target.hasAttribute('data-quick-add-modal')) return;
    if (!target.querySelector('.js-email-input')) return;

    target.querySelector('.product-form').classList.remove('has-success')

    target.querySelector('.js-email-input')?.classList[variant.available ? 'add': 'remove']('hidden')
    target.querySelector('.js-atc-btn')?.classList[variant.available ? 'remove': 'add']('hidden')
    target.querySelector('.js-subscribe-btn')?.classList[variant.available ? 'add': 'remove']('hidden')

    if (variant.available) {
      target.querySelector('.js-email-input').setAttribute('disabled', '')
    } else {
      target.querySelector('.js-email-input').removeAttribute('disabled')
    }
  })
  document.addEventListener('click', e => {
    const button = e.target.closest('.js-subscribe-btn')
    if (!button) return;
    e.preventDefault();

    const form = e.target.closest('form')
    const emailInput = form.querySelector('.js-email-input')
    const formData = new FormData(form)
    const id = formData.get('id')
    const email = formData.get('email')
    const emailError = form.querySelector('.email-error');
    const msg = document.querySelector('.product__notification__message')

    for(var pair of formData.entries()){
      console.log(pair[0], pair[1]);
    }
    emailInput.classList.remove('error')
    emailError.style.display = 'none'
    msg.style.display = 'none'


    if (!validateEmail(email)) {
      emailInput.classList.add('error')
      emailError.style.display = 'block'
      return
    }

    button.classList.add('is-loading');

    const payload = {
      data: {
        type: 'back-in-stock-subscription',
        attributes: {
          profile: {
            data: {
              type: 'profile',
              attributes: {
                email
              }
            }
          },
          channels: [
            'EMAIL'
          ]
        },
        relationships: {
          variant: {
            data: {
              type: 'catalog-variant',
              id: `$shopify:::$default:::${id}`
            }
          }
        }
      }
    }

    fetch(`https://a.klaviyo.com/client/back-in-stock-subscriptions?company_id=${ window.theme.settings.klaviyoCompanyId }`, {
      method: 'POST',
      headers: {
        accept: 'application/vnd.api+json',
        revision: '2024-10-15',
        'content-type': 'application/vnd.api+json'
      },
      body: JSON.stringify(payload)
    }).then(res => res.text())
    .then(() => {
      emailInput.value = ''
      form.classList.add('has-success')
      msg.style.display = 'block'

    })
    .catch(err => console.error(err))
    .finally(() => {
      button.classList.remove('is-loading');

      setTimeout(() => {
        form.classList.remove('has-success')
        msg.style.display = 'none'
      }, 3000)
    });
  })

  const formId = 'VKtmNV'; 
  const formIdSignedOut = 'zyt2kG'
  const formConsent = document.querySelector('form[data-cf-form="' + formId + '"]') || document.querySelector('form[data-cf-form="' + formIdSignedOut + '"]')
  document.addEventListener('cf:ready', function() {
    if (!Boolean(formConsent)) return;
    const innerPanel = document.querySelector('.loyalty-panel__inner__content')
    const guestText = document.querySelector('.loyalty-points-guest')

    formConsent.addEventListener('cf:form_submitted', function(event) {
      innerPanel.classList.add('hidden')
      guestText.classList.add('hidden')
    })
})
  /* Button update for new-product start */
    function updateCustomATCDisplay(variant, qty) {
      let price = 0
      const plus_btn = document.querySelector('.custom-atc-plus');
      const minus_btn = document.querySelector('.custom-atc-minus');
      if(variant){
        if (variant.available){
          const sub_check = document.getElementById('activate-subscription')?.checked;
          document.querySelector('.js-atc-btn').classList.remove('hidden');
          if(sub_check == true){
            plus_btn.style.display = 'none';
            minus_btn.style.display = 'none';
          }else{
            plus_btn.style.display = 'flex';
            minus_btn.style.display = 'flex';
          }
        }else{
          plus_btn.style.display = 'none';
          minus_btn.style.display = 'none';
        }
      }
      if (!variant){
        let price_text = document.querySelector('.custom-atc-total').getAttribute('data-price');
        let price_Float = parseFloat(price_text);
        price =  price_Float.toFixed(2);
      }else{
        price = variant.price / 100;
      }
      document.querySelector('.custom-atc-total').textContent = price ? (price * qty).toFixed(2) : '0.00';
      document.querySelectorAll('.custom-atc-qty').forEach(el => el.textContent = qty);
      const qtyInput = document.querySelector('input.custom-atc-qty');
      if (qtyInput) qtyInput.value = qty;
      const plus = document.querySelector('.custom-atc-plus');
      if (plus) {
        if (qty >= 10) {
          plus.classList.add('disabled');
          plus.setAttribute('aria-disabled', 'true');
        } else {
          plus.classList.remove('disabled');
          plus.removeAttribute('aria-disabled');
        }
      }
      if(minus_btn){
        if (qty == 1) {
          minus_btn.classList.add('disabled');
          minus_btn.setAttribute('aria-disabled', 'true');
          document.querySelector('.atc-main-wrap').classList.remove('has_more');
        } else {
          minus_btn.classList.remove('disabled');
          minus_btn.removeAttribute('aria-disabled');
        }
      }
    }
let customATCListenersAttached = false;
    function attachCustomATCListeners() {
        if (customATCListenersAttached) return; // already attached
        customATCListenersAttached = true;
      let qty = 1;
      let currentVariant = window?.Shopify?.currentVariant || null;

      const minus = document.querySelector('.custom-atc-minus');
      const plus = document.querySelector('.custom-atc-plus');
      if (!minus || !plus) return;

      minus.addEventListener('click', function(e) {
        qty = document.querySelector('input.custom-atc-qty').value;
        e.preventDefault();
        if (qty > 1) {
          qty--;
          updateCustomATCDisplay(currentVariant, qty);
        }
         if (qty == 1) {
          document.querySelector('.atc-main-wrap').classList.remove('has_more');
        }
      });

      plus.addEventListener('click', function(e) {
        qty = document.querySelector('input.custom-atc-qty').value;
        e.preventDefault();
        if (qty < 10) {
          qty++;
          updateCustomATCDisplay(currentVariant, qty);
          document.querySelector('.atc-main-wrap').classList.add('has_more');
        }
      });

      document.addEventListener('theme:variant:change', function(e) {
        if (!e.detail || !e.detail.variant) return;
        currentVariant = e.detail.variant;
        qty = 1;
        updateCustomATCDisplay(currentVariant, qty);
      });

      // Initial update
      if (currentVariant) updateCustomATCDisplay(currentVariant, qty);
    }

    document.addEventListener('DOMContentLoaded', function() {
       if (!document.body.classList.contains('template--new-product')) return;
      attachCustomATCListeners();
    });
    document.addEventListener("theme:cart:change", function(e) {
      if (!document.body.classList.contains('template--new-product')) return;
        const aty_qty = document.querySelectorAll('.custom-atc-qty');
        if(aty_qty.length > 0 ){
          aty_qty.forEach(el => el.textContent = 1);
          document.querySelector('input.custom-atc-qty').value = 1; 
          const sub_check = document.getElementById('activate-subscription') ? document.getElementById('activate-subscription').checked : false;
          if(sub_check == false){
            const priceText = document.querySelector('.product__price [data-product-price]').textContent;
            const single_price = parseFloat(priceText.replace(/[^\d.]/g, '')).toFixed(2);
            document.querySelector('.custom-atc-total').textContent = single_price;
            const plus_btn = document.querySelector('.custom-atc-plus');
            const minus_btn = document.querySelector('.custom-atc-minus');
            minus_btn.classList.add('disabled');
            plus_btn.classList.remove('disabled');
            document.querySelector('.atc-main-wrap').classList.remove('has_more');
          }
          attachCustomATCListeners();
        }
    });
    document.getElementById('activate-subscription')?.addEventListener('change', function(event) {
      if (!document.body.classList.contains('template--new-product')) return;
      const plus_btn = document.querySelector('.custom-atc-plus');
      const minus_btn = document.querySelector('.custom-atc-minus');
      const has_subscription = document.querySelector('.custom-atc-label.has-subscription');
      const no_subscription = document.querySelector('.custom-atc-label:not(.has-subscription)');
      if(event.target.checked == true){
        plus_btn.style.display = 'none';
        minus_btn.style.display = 'none';
        no_subscription.style.display = 'none';
        has_subscription.style.display = 'block';
      }else{
        plus_btn.style.display = 'flex';
        minus_btn.style.display = 'flex';
        has_subscription.style.display = "none";
        no_subscription.style.display = "block";
        const aty_qty = document.querySelectorAll('.custom-atc-qty');
        if(aty_qty.length > 0 ){
          aty_qty.forEach(el => el.textContent = 1);
        }
        const priceText = document.querySelector('.product__price [data-product-price]').textContent;
        const single_price = parseFloat(priceText.replace(/[^\d.]/g, '')).toFixed(2);
        document.querySelector('.custom-atc-total').textContent = single_price;
        document.querySelector('.custom-atc-total').setAttribute('data-price',single_price)
        minus_btn.classList.add('disabled');
        minus_btn.setAttribute('aria-disabled', 'true');
        plus_btn.classList.remove('disabled');
        plus_btn.removeAttribute('aria-disabled');
        document.querySelector('.atc-main-wrap').classList.remove('has_more');
      }
      document.querySelector('input.custom-atc-qty').value = 1; 
      attachCustomATCListeners();
    });

  /* Button update for new-product end */

  // ^^ Keep your scripts inside this IIFE function call to
  // avoid leaking your variables into the global scope.

})();


document.addEventListener('DOMContentLoaded', () => {
  const mobileMenu = document.querySelector('#header-menu')
  const accordionItems = mobileMenu.querySelectorAll('.accordion-item')

  accordionItems.forEach(accordionItem => {
    accordionItem.addEventListener('click', e => {
      if(e.target.classList.contains('accordion-item-link')) return
      e.preventDefault()
      e.stopPropagation();
      e.stopImmediatePropagation();

      accordionItem.classList.toggle('is-open')
    })
    })




// document.addEventListener("theme:cart:change", ()=> didcountNinjaCall() )

})

const moneyFormat = "${{amount}}"

/**
 * Format money values based on your shop currency settings
 * @param  {Number|string} cents - value in cents or dollar amount e.g. 300 cents
 * or 3.00 dollars
 * @param  {String} format - shop money_format setting
 * @return {String} value - formatted value
 */
function formatMoney(cents, format) {
  if (typeof cents === "string") {
    cents = cents.replace(".", "")
  }
  let value = ""
  const placeholderRegex = /\{\{\s*(\w+)\s*\}\}/
  const formatString = format || moneyFormat

  function formatWithDelimiters(number, precision = 2, thousands = ",", decimal = ".") {
    if (isNaN(number) || number == null) {
      return 0
    }

    number = (number / 100.0).toFixed(precision)

    const parts = number.split(".")
    const dollarsAmount = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, `$1${thousands}`)
    const centsAmount = parts[1] ? decimal + parts[1] : ""

    return dollarsAmount + centsAmount
  }

  switch (formatString.match(placeholderRegex)[1]) {
    case "amount":
      value = formatWithDelimiters(cents, 2)
      break
    case "amount_no_decimals":
      value = formatWithDelimiters(cents, 0)
      break
    case "amount_with_comma_separator":
      value = formatWithDelimiters(cents, 2, ".", ",")
      break
    case "amount_no_decimals_with_comma_separator":
      value = formatWithDelimiters(cents, 0, ".", ",")
      break
    case "amount_with_apostrophe_separator":
      value = formatWithDelimiters(cents, 2, "'", ".")
      break
    case "amount_no_decimals_with_space_separator":
      value = formatWithDelimiters(cents, 0, " ", "")
      break
    case "amount_with_space_separator":
      value = formatWithDelimiters(cents, 2, " ", ",")
      break
    case "amount_with_period_and_space_separator":
      value = formatWithDelimiters(cents, 2, " ", ".")
      break
  }

  return formatString.replace(placeholderRegex, value)
}





(function() {
  const backCartBtn = document.querySelector('.cart__button-continue .btn');
  if(!Boolean(backCartBtn)) return
  const continueShoppingText = document.querySelector('.continue-shopping-text');
  const backButtonText = document.querySelectorAll('.back-shopping-text');
  const lastPageUrl = document.referrer;
  let url = sessionStorage.getItem("lastVisitedUrl");
  console.log(Boolean(url))

  if(Boolean(lastPageUrl)) {
    sessionStorage.setItem("lastVisitedUrl", lastPageUrl);
    url = sessionStorage.getItem("lastVisitedUrl");
  }

  if(Boolean(url)) {
    backCartBtn.href=url
    backButtonText.forEach(btn => {
      btn.style.display = 'flex'
    })
    continueShoppingText.style.display = 'none';

  } else {
    continueShoppingText.style.display = 'block';
    backButtonText.forEach(btn => {
      btn.style.display = 'none'
    })
  }

})()